import { CompanyReportMapper } from "@/adapters/CompanyReport.mapper";
/**
 * Строка `corp_my_orders` (§4.4, кабинет) — та же форма, что `v_corp_orders` (staff), минус
 * `client_id`/`technician_id`/`route_id` (`zCorpOrderRowDto` ослаблен до `.nullish()`, TECH-CORP-008).
 * Тонкая обёртка: переиспользует `CompanyReportMapper.orderToDomain` (экспортирован).
 */
export const CorpOrderMapper = {
    rowToDomain(raw) {
        return CompanyReportMapper.orderToDomain(raw);
    },
};
